// PreviewScheduling.js
import React from 'react';
import { Box, Grid, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';               // uses .steps-list and .thumb defined earlier

export default function PreviewScheduling() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Preview&nbsp;&amp;&nbsp;Scheduling
      </Typography>

          <Typography paragraph>
            Before any campaign goes live, PostSheet gives you a final sanity
            check. Use the&nbsp;<strong>Preview</strong> and&nbsp;
            <strong>Schedule</strong> tabs to confirm content and timing.
          </Typography>

          {/* Preview bullets */}
          <List className="steps-list" sx={{ pl: 3, listStyleType: 'disc' }}>
            <ListItem>
              <strong>Preview</strong> — renders the first&nbsp;3 personalised
              messages so you can spot merge-field issues.
            </ListItem>
            <ListItem>
              <strong>Schedule</strong> — pick a future send date&nbsp;•
              leave blank to run immediately.
            </ListItem>
            <ListItem>
              Campaigns auto-start on the chosen date, or you can press&nbsp;
              <em>Run&nbsp;Now</em> from the detail screen.
            </ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Optional Settings
          </Typography>

          {/* Settings bullets */}
          <List className="steps-list" sx={{ pl: 3, listStyleType: 'disc' }}>
            <ListItem>Save as reusable <em>Template</em>.</ListItem>
            <ListItem>
              <em>Stop on failed items</em> — halts the run after the first
              critical error.
            </ListItem>
            <ListItem>
              <em>Track emails</em> — enables open &amp; bounce tracking.
            </ListItem>
            <ListItem>
              <em>Track links</em> — wraps URLs for click analytics.
            </ListItem>
          </List>
              <img
            src="../../static/docs/PreviewSchedule.jpg"
            alt="Preview & scheduling screen"
            className="step-img"
          />
          <Typography paragraph sx={{ mt: 2 }}>
            Don’t forget to give the run a clear <strong>Campaign&nbsp;Name</strong> in the
            top-right of the preview card. Otherwise your campaing will be named as "Job #total count of jobs you have" 
          </Typography>
          
    

        {/* ───── Right column : screenshot ───── */}
    
    </Box>
  );
}
